import Vue from 'vue'

export default {
  setLocale: (state, { locale }) => {
    state.locale = locale
  },
  setLanguage: (state, { lang }) => {
    state.currentLanguage = lang
  },
  setUserInfo: (state, userData) => {
    state.userData = userData.user
    state.cms_access_token = userData.token
    if(userData.token){
      state.loggedin = true
    }else{
      state.loggedin = false
    }
  },
  setContainerClass: (state, className ) => {
    state.containerClass = className
  },
  setLayout: (state, payload ) => {
    state.layout = payload
  },
  setDashboardTitle: (state, title ) => {
    state.dashboardTitle = title
  },
  SET_MENU_DATA: (state, data) => {
      state.menuData = data;
  },
  SET_ACTION_TYPE: (state, data) => {
      state.actionType = data;
  },
  SET_MASTER_TYPE: (state, type) => {
      state.masterType = type;
  },
  SET_MASTER_TYPE_NAME: (state, data) => {
      state.masterTypeName = data;
  },
  SET_SERVICE_TYPE_NAME: (state, data) => {
    state.serviceTypeName = data;
},
  
}


// WEBPACK FOOTER //
// ./src/store/mutations.js